<div class="main">
    <div class="row clear">
        <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="text-header text-center">Certified by MERALCO Contractors Program</div>
            <div class="text-header text-center">Terms and Conditions</div>
            <br>
            <div class="text-normal text-justify">
                I am availing of the Private Electrical Contractors Certified by Meralco (“PECCBM”) Program,
                in connection with my application of electric service or other related services with
                Manila Electric Company (“MERALCO”), and agree to the following terms and conditions:
            </div>
            <br>
            <table aria-describedby="terms table">
                <thead>
                <tr>
                    <th></th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>1.</td>
                        <td>I shall be dealing directly with the PECCBM Contractor of my choice including the payment of its services.</td>
                    </tr>
                    <tr>
                        <td>2.</td>
                        <td>I fully understand that the PECCBM Contractor shall be solely responsible for any claim, action or liability which may result
                            from the performance of its services and those of its personnel and contractors, if any. I hereby acknowledge that the PECCBM
                            Contractor personnel are not employees or agents of MERALCO.
                        </td>
                    </tr>
                    <tr>
                        <td>3.</td>
                        <td>I understand that MERALCO is not involved and does not participate in my engagement of the services of the PECCBM 
                            Contractor. For this purpose, I hereby waive in favor of MERALCO, its directors, employees or agents, any and all 
                            rights of action, claims or demands for any loss or damage that I may suffer or incur arising from or in connection 
                            with the performance of services by the PECCBM Contractor and with my participation in or my availing of the PECCBM Program.
                        </td>
                    </tr>
                    <tr>
                        <td>4.</td>
                        <td>I voluntarily provide my personal and sensitive personal information to MERALCO (“Personal Data”) solely to enable MERALCO to
                            process and notify me about the service request I lodged in the PECCBM Online Platform. I understand that I may seek assistance
                            from its Data Privacy Office to exercise my rights as a data subject over the Personal Data that I provided.
                        </td>
                    </tr>
                    <tr>
                        <td>5.</td>
                        <td>I hereby allow MERALCO to share my Personal Data with the PECCBM Contractor of my choosing,
                            in order for the PECCBM Contractor to successfully perform intended services, which includes but
                            is not limited to the required services in connection with my application of electric service
                            or other related services.
                        </td>
                    </tr>
                <tr>
                    <td>6.</td>
                    <td>I understand that MERALCO’s processing of my Personal Data is limited only to the purposes
                        stated above. I further understand that the PECCBM Contractor’s processing of my shared Personal
                        Data to successfully perform intended services is independent of MERALCO’s. As such, the PECCBM
                        Contractor’s use of my Personal Data for their own legitimate purpose/s is outside the scope of
                        MERALCO’s personal data processing.
                    </td>
                </tr>
                <tr>
                    <td>7.</td>
                    <td>I hereby allow, further, the PECCBM Contractor to share with MERALCO any information gathered
                        in the performance of the services for the completion of my application of electric service or
                        other related services for which the PECCBM Contractor has been engaged.
                    </td>
                </tr>
                <tr>
                    <td>8.</td>
                    <td>I certify and warrant that the Data so disclosed to MERALCO are true, accurate and correct.
                        Should any information in the Data become incorrect, I shall endeavor to undertake best efforts
                        to inform MERALCO of any change in the Data, which shall be then shared with the
                        PECCBM Contractor so engaged.
                    </td>
                </tr>
                <tr>
                    <td>9.</td>
                    <td>I shall defend, protect, indemnify and hold MERALCO, its directors, officers, employees and
                        agents, free and harmless from and against any and all claims, actions, losses, damages and
                        expenses (including reasonable attorney's fees) arising out of any inaccuracy or error in the
                        Data known to me or ought to have been known to me, and which I failed to bring to MERALCO’s
                        attention.
                    </td>
                </tr>
                <tr>
                    <td>10.</td>
                    <td>MERALCO may, from time to time, amend or modify this PECCBM Program Terms and Conditions without
                        prior notice and MERALCO may, at any time, modify, suspend or permanently stop and/or remove any
                        aspect or feature of the PECCBM Program.
                    </td>
                </tr>
                <tr>
                    <td>11.</td>
                    <td>If any of the terms and conditions herein stated is found to be unenforceable or invalid under
                        any applicable law or rules, such unenforceability or invalidity shall not render the other
                        terms or conditions as unenforceable or invalid as a whole, and such unenforceable or invalid
                        provisions shall be deleted without affecting the remaining provisions.
                    </td>
                </tr>
                <tr>
                    <td>12.</td>
                    <td>If I violate any of the terms and conditions herein, MERALCO may use the same as ground to
                        deny my future availing of participation in the PECCBM Program, without prejudice to its
                        right to avail of any appropriate remedies under the law.
                    </td>
                </tr>
                <tr>
                    <td>13.</td>
                    <td>I may give feedback and comments regarding my participation in the PECCBM Program,
                        including the performance of PECCBM Contractor I have engaged with, as part of
                        MERALCO’s objective to improve its services to customers.
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
